import React, { useEffect, useState } from "react";
import { Collapse } from "react-bootstrap"; // Import Collapse for sub-links
import { FaChevronDown, FaChevronUp } from 'react-icons/fa'; // Import arrow icons

const SideBar = () => {
    const [isAdmin, setIsAdmin] = useState(false);
    const [isEcosystemAdmin, setIsEcosystemAdmin] = useState(false);
    const [isMenuOpen, setMenuOpen] = useState(false);
    const [isReportsOpen, setReportsOpen] = useState(false); // State for Reports
    const [role, setRole] = useState();
    const [cart, setCart] = useState();

    const toggleMenu = () => {
        setMenuOpen(!isMenuOpen);
    };

    const toggleReports = () => {
        setReportsOpen(!isReportsOpen);
    };

    // Function to check role and category
    const checkUserRoles = () => {
        const role = localStorage.getItem('async_role');
        const category = localStorage.getItem('async_category');
        setRole(role);
        setCart(category);

        console.log('Fetched role:', role);
        console.log('Fetched category:', category);

        if (role === 'Admin') {
            setIsAdmin(true);
        } else {
            setIsAdmin(false);
        }

        if (category === 'ecosystem_admin') {
            setIsEcosystemAdmin(true);
        } else {
            setIsEcosystemAdmin(false);
        }

        if (!role) {
            window.location.href = '/';
        }
    };

    useEffect(() => {
        checkUserRoles();
    }, []);

    return (
        <div>
            <head>
                <meta charset="utf-8" />
                <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
                <title>Concept - Bootstrap 4 Admin Dashboard Template</title>
                <link rel="stylesheet" href="../assets/vendor/bootstrap/css/bootstrap.min.css" />
                <link href="../assets/vendor/fonts/circular-std/style.css" rel="stylesheet" />
                <link rel="stylesheet" href="../assets/libs/css/style.css" />
                <link rel="stylesheet" href="../assets/vendor/fonts/fontawesome/css/fontawesome-all.css" />
            </head>
            <body>
                <div className="nav-left-sidebar sidebar-dark" style={{ fontSize: '10px', backgroundColor: '#B03F82' }}>
                    <div className="menu-list">
                        <nav className="navbar navbar-expand-lg navbar-light">
                            <a className="d-xl-none d-lg-none" href="0">Dashboard</a>
                            <button className="navbar-toggler" type="button" onClick={toggleMenu} aria-label="Toggle navigation">
                                <span className="navbar-toggler-icon"></span>
                            </button>
                            <div className={`collapse navbar-collapse${isMenuOpen ? ' show' : ''}`}>
                                <ul className="navbar-nav flex-column" style={{ paddingLeft: '0' }}>
                                    <li className="nav-divider" style={{ color: '#fff', textAlign: 'left', paddingLeft: '0' }}>
                                        Menu
                                    </li>
                                    <li className="nav-item">
                                        <a className="nav-link" style={{ color: '#fff', textAlign: 'left', paddingLeft: '0' }} href="/CompanySetup">Company Setup</a>
                                    </li>
                                    <li className="nav-item">
                                        <a className="nav-link" style={{ color: '#fff', textAlign: 'left', paddingLeft: '0' }} href="/BranchSetup">Branch Setup</a>
                                    </li>
                                    <li className="nav-item">
                                        <a className="nav-link" style={{ color: '#fff', textAlign: 'left', paddingLeft: '0' }} href="/UserSetup">User Setup</a>
                                    </li>
                                    <li className="nav-item">
                                        <a className="nav-link" style={{ color: '#fff', textAlign: 'left', paddingLeft: '0' }} href="/pos">POS</a>
                                    </li>
                                    <li className="nav-item">
                                        <a className="nav-link" style={{ color: '#fff', textAlign: 'left', paddingLeft: '0' }} href="/saleHistory">Sales History</a>
                                    </li>
                                    <li className="nav-item">
                                        <a className="nav-link" style={{ color: '#fff', textAlign: 'left', paddingLeft: '0' }} href="/PettyCash">Petty Cash</a>
                                    </li>
                                    <li className="nav-item">
                                        <a className="nav-link" style={{ color: '#fff', textAlign: 'left', paddingLeft: '0' }} href="/inventory">Inventory</a>
                                    </li>
                                    <li className="nav-item">
                                        <a className="nav-link" style={{ color: '#fff', textAlign: 'left', paddingLeft: '0' }} href="/EndShift">End Shift</a>
                                    </li>
                                    <li className="nav-item">
                                        <div onClick={toggleReports} style={{ color: '#fff', cursor: 'pointer', textAlign: 'left', paddingLeft: '0', fontSize: '1.4em' }}> {/* Increased font size */}
                                        Reports
                                            {isReportsOpen ? <FaChevronUp className="me-2" /> : <FaChevronDown className="me-2" />}
                                           
                                        </div>
                                    </li>
                                    <Collapse in={isReportsOpen}>
                                        <ul className="navbar-nav flex-column ms-4">
                                            <li className="nav-item">
                                                <a className="nav-link" style={{ color: '#fff', textAlign: 'left' }} href="/DailySalesReports">Daily Sales Report</a>
                                            </li>
                                            <li className="nav-item">
                                                <a className="nav-link" style={{ color: '#fff', textAlign: 'left' }} href="/WeeklySalesReports">Weekly Sales Report</a>
                                            </li>
                                            <li className="nav-item">
                                                <a className="nav-link" style={{ color: '#fff', textAlign: 'left' }} href="/InventoryMovementReports">Inventory Movement Report</a>
                                            </li>
                                        </ul>
                                    </Collapse>
                                    <li className="nav-item" style={{ color: 'white' }}>
                                        <a className="nav-link" style={{ color: '#fff', textAlign: 'left', paddingLeft: '0'}} href="/">Logout</a>
                                    </li>
                                </ul>
                            </div>
                        </nav>
                    </div>
                </div>
            </body>
        </div>
    );
}

export default SideBar;